export type DisplayMode = "web" | "compact";

export const kDisplayModeAttribute = "data-display-mode";

/**
 * Vanilla-extract selector fragments for mode-specific styles:
 * `selectors: { [kCompactSelector]: { ... } }`. This module is import-free so
 * `.css.ts` files (evaluated in Node by the vanilla-extract plugin) can use
 * these constants without dragging in window-touching modules.
 */
export const kCompactSelector = `html[${kDisplayModeAttribute}="compact"] &`;
export const kWebSelector = `html[${kDisplayModeAttribute}="web"] &`;

/** Compact = any embedded host: the Labs plugin webview or the sidepanel iframe. */
export const deriveDisplayMode = (isEmbedded: boolean): DisplayMode =>
    isEmbedded ? "compact" : "web";

/**
 * The website at phone width. A media query rather than a display mode: the
 * same page is "web" on a laptop and on a phone, and only the layout differs.
 * Pair it with `kWebSelector` so the plugin surfaces, which are narrow by
 * design and have their own chrome, are never caught by it.
 */
export const kNarrowViewportQuery = "(max-width: 640px)";
